/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedSkyscraperAd_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": "SbSharedSkyscraperAd_itemSearch";
};
export type SbSharedSkyscraperAd_itemSearch$data = SbSharedSkyscraperAd_itemSearch;
export type SbSharedSkyscraperAd_itemSearch$key = {
    readonly " $data"?: SbSharedSkyscraperAd_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedSkyscraperAd_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedSkyscraperAd_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ab9bd5f5f1352deba7eff180c5e8ee97';
export default node;
